import { createApiClientForEndpoint } from "../lib/apiClient";

const api = createApiClientForEndpoint("");

export const fetchEvacuationPlans = () => api.get("/evacuation");

export const fetchEvacuationPlanById = (id) => api.get(`/evacuation/${id}`);

export const fetchEvacuationPlansByType = (type) =>
  api.get(`/evacuation/type/${type}`);

export const fetchEvacuationPlansByOrganisation = (organisationId) =>
  api.get(`/evacuation/organisation/${organisationId}`);

export const createEvacuationPlan = (data) => api.post("/evacuation", data);

export const updateEvacuationPlan = (id, data) =>
  api.put(`/evacuation/${id}`, data);

export const deleteEvacuationPlan = (id) => api.delete(`/evacuation/${id}`);

export const fetchEmergencyTypes = () => api.get("/evacuation/types");
